module.exports = __webpack_public_path__ + "static/media/retailLogo.bfb08e76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/retailLogo.png
// module id = 2453
// module chunks = 0